module.exports = __webpack_public_path__ + "8557e8d7dffe3b9e2ffcc773dbb0ec0d.pdf";